import React from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { FormattedMessage } from "react-intl";
import { TextInput } from "../../../../common/form";
import AccountSection from "./AccountSection";

class BusinessUnitsSection extends React.Component {
  renderBusinessUnitFields() {
    return (
      <div className="sub-block">
        {this.props.businessUnit.map((item) => (
          <Field
            id={`businessUnitAccount${item.businessUnitNameId}`}
            key={item.businessUnitNameId}
            name={`accountBusinessUnits['${item.accountBusinessUnitId}'].businessUnitAccount`}
            component={TextInput}
            type="text"
            label={
              <FormattedMessage
                id={`admin.accounts.businessunits.${item.businessUnitNameId}`}
              />
            }
          />
        ))}
      </div>
    );
  }
  render() {
    return (
      <AccountSection
        title={<FormattedMessage id="admin.accounts.businessunits.heading" />}
      >
        {this.renderBusinessUnitFields()}
      </AccountSection>
    );
  }
}

BusinessUnitsSection.propTypes = {
  businessUnit: PropTypes.array,
};

export default BusinessUnitsSection;



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/accounts/formSections/BusinessUnitsSection.js